import { LogsService } from '@gtpl/shared-services/user-logs';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { forwardRef, Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { EmployeeLeavesModule } from '../employee-leaves/employee-leaves.module';
import { TypesOfLeavesAdapter } from './dto/types-of-leaves.adapter';
import { TypesOfLeavesRepository } from './repo/types-of-leaves.repository';
import { TypesOfLeavesController } from './types-of-leaves.controller';
import { TypesOfLeavesService } from './types-of-leaves.service';

@Module({
  imports: [
    TypeOrmModule.forFeature([TypesOfLeavesRepository]),
    forwardRef(() => EmployeeLeavesModule)
  ],
  controllers: [TypesOfLeavesController],
  providers: [TypesOfLeavesService,TypesOfLeavesAdapter,ApplicationExceptionHandler,LogsService],
  exports:[TypesOfLeavesService,TypesOfLeavesAdapter]
})
export class TypesOfLeavesModule {}
